import { render, staticRenderFns } from "./Succeed.vue?vue&type=template&id=37376166&scoped=true"
import script from "./Succeed.vue?vue&type=script&lang=js"
export * from "./Succeed.vue?vue&type=script&lang=js"
import style0 from "./Succeed.vue?vue&type=style&index=0&id=37376166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_3rwm2qttujvjuolkwtduiruple/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37376166",
  null
  
)

export default component.exports